import { render, staticRenderFns } from "./AccountGroupForm.vue?vue&type=template&id=666d2ada&scoped=true&"
import script from "./AccountGroupForm.vue?vue&type=script&lang=js&"
export * from "./AccountGroupForm.vue?vue&type=script&lang=js&"
import style0 from "./AccountGroupForm.vue?vue&type=style&index=0&id=666d2ada&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "666d2ada",
  null
  
)

export default component.exports